// MembershipList.js

import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    IconButton,
} from '@mui/material';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Visibility } from '@mui/icons-material';

import './MembershipList.css';


const MembershipList = ({ members, onSelectMember, className }) => {
    return (
        <TableContainer component={Paper} className={`members-table-container ${className}`}>
            <Table size="small" aria-label="a dense table">
                <TableHead className="members-table-head">
                    <TableRow className="members-header-row">
                        <TableCell align="center" className="members-header-cell"></TableCell>
                        <TableCell align="center" className="members-header-cell">ID</TableCell>
                        <TableCell align="center" className="members-header-cell">Name</TableCell>
                        <TableCell align="center" className="members-header-cell">Email</TableCell>
                        <TableCell align="center" className="members-header-cell">Member Since</TableCell>
                        <TableCell align="center" className="members-header-cell">Enabled?</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {members.map((member) => (
                        <TableRow key={member.userId}>
                            <TableCell align="center" className="members-table-cell">
                                <IconButton onClick={() => onSelectMember(member)}>
                                    <Visibility className="icon" />
                                </IconButton>
                            </TableCell>
                            <TableCell align="center" className="members-table-cell">{member.userId}</TableCell>
                            <TableCell align="left" className="members-table-cell">{`${member.user.firstName || 'N/A'} ${member.user.lastName || 'N/A'}`}</TableCell>
                            <TableCell align="left" className="members-table-cell">{member.user.email}</TableCell>
                            <TableCell align="center" className="members-table-cell">{new Date(member.membershipDate).toLocaleDateString()}</TableCell>
                            <TableCell align="center" className="members-table-cell">
                                {member.enabled ? (
                                    <CheckBoxIcon className="icon checked" />
                                ) : (
                                    <CheckBoxOutlineBlankIcon className="icon" />
                                )}
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer >
    );
};

export default MembershipList;
